import { generateAirwayReport } from "./AirwayReport.js";
import { generateCrossSectionReport, generateCutsReport } from "@/components/dicom/reports/DicomReports.js";

async function generateReport(reportName) {
  console.log("generateReport", reportName);

  if (reportName === "airway") {
    await generateAirwayReport();
  }
  else if (reportName === "crossSection") {
    await generateCrossSectionReport();
  }
}

export { generateReport };
